
import { ValidationController } from "stimulus-validation";

export default class extends ValidationController {
    static rules = {
      split_transaction: { presence: { allowEmpty: false } }
    }
}